import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportAccessReportExcelUseCaseInterface } from 'domain/usecases';

export class RemoteExportAccessReportExcel
  implements ExportAccessReportExcelUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportAccessReportExcelUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportAccessReportExcelUseCaseInterface.Params,
  ): Promise<ExportAccessReportExcelUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, { ...params });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
